module.exports = __webpack_public_path__ + "assets/TParallelDetailed.c38feab7d63d29cd4c0a474db3f7069f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TParallelDetailed.png
// module id = 581
// module chunks = 0